import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiCheck } from "react-icons/fi";
import PropTypes from "prop-types";
import { FormatPoints } from "../../../../lib";

const HotelSummary = ({ envisionData, getHotelRoom, getCancellationPolicy, getHotelNights, getHotelDailyPoints, getHotelTaxPoints }) => {
  if (!envisionData) return null;
  
  return (
    <div id="hotelCard" className="mb-3">
      <Row className="mb-4">
        <Col>
          <p className="font-wl-500 text-md color-text-dark mb-0">Quarto</p>
          <p className="text-sm text-muted mb-0">
            {getHotelRoom()?.name || "(Nome do modelo do quarto)"}
          </p>
          {getCancellationPolicy() && (
            <p
              className="text-sm mb-0 mt-2 d-flex align-items-center"
              style={{
                color: getCancellationPolicy().isFree ? "#157347" : "var(--text-dark)",
                fontWeight: 500,
              }}
            >
              {getCancellationPolicy().isFree && <FiCheck className="me-2" size={14} />}
              {getCancellationPolicy().title}
            </p>
          )}
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <p className="text-sm text-muted mb-0">
            {getHotelNights()} diária{getHotelNights() > 1 ? "s" : ""}
          </p>
        </Col>
        <Col className="text-end">
          <p className="text-sm color-text-dark mb-0">
            {FormatPoints(getHotelDailyPoints())} pts
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p className="text-sm text-muted mb-0">Taxa</p>
        </Col>
        <Col className="text-end">
          <p className="text-sm color-text-dark mb-0">
            {FormatPoints(getHotelTaxPoints())} pts
          </p>
        </Col>
      </Row>
    </div>
  );
};

HotelSummary.propTypes = {
  envisionData: PropTypes.object,
  getHotelRoom: PropTypes.func.isRequired,
  getCancellationPolicy: PropTypes.func.isRequired,
  getHotelNights: PropTypes.func.isRequired,
  getHotelDailyPoints: PropTypes.func.isRequired,
  getHotelTaxPoints: PropTypes.func.isRequired,
};

export default HotelSummary;
